import { Link } from "wouter";
import { motion } from "framer-motion";
import { ArrowRight, Gift } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ScribPostLogo } from "@/components/scribpost-logo";

export default function GiftSuccessPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background text-foreground relative overflow-hidden px-4">
      <div className="bg-orb-1" aria-hidden="true" />
      <div className="bg-orb-2" aria-hidden="true" />
      <div className="bg-orb-3" aria-hidden="true" />
      <div className="bg-grid" aria-hidden="true" />

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ type: "spring", stiffness: 280, damping: 28 }}
        className="w-full max-w-md relative z-10"
      >
        <div className="bg-card border border-border rounded-2xl shadow-2xl shadow-primary/10 p-8 space-y-6 text-center">
          <div className="flex justify-center mb-2">
            <ScribPostLogo size="lg" />
          </div>

          <div className="space-y-4">
            <div className="text-6xl">🎁</div>
            <div className="w-16 h-16 rounded-full bg-emerald-500/15 border border-emerald-500/25 flex items-center justify-center mx-auto">
              <Gift className="w-8 h-8 text-emerald-400" />
            </div>

            <div>
              <h1 className="font-display font-bold text-2xl mb-2">Gift sent successfully!</h1>
              <p className="text-muted-foreground text-sm leading-relaxed">
                The recipient will receive a branded email with their personal redemption link shortly. They can redeem it to activate their ScribPost Pro membership.
              </p>
            </div>

            <div className="bg-secondary/30 border border-border rounded-xl p-4 text-sm text-muted-foreground text-left space-y-2">
              <p className="font-medium text-foreground">What happens next:</p>
              <ul className="space-y-1.5 list-disc list-inside">
                <li>The recipient receives a gift email with a redemption link</li>
                <li>They create or log into their ScribPost account</li>
                <li>Their Pro membership activates immediately</li>
                <li>The gift link is valid for one year</li>
              </ul>
            </div>

            <div className="flex flex-col gap-3 pt-2">
              <Link href="/">
                <Button className="w-full h-11 rounded-xl font-bold bg-gradient-to-r from-primary to-accent hover:opacity-90">
                  Go to ScribPost
                  <ArrowRight className="w-4 h-4 ml-2" />
                </Button>
              </Link>
              <Link href="/pricing">
                <Button variant="outline" className="w-full h-11 rounded-xl font-semibold">
                  Gift another membership
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </motion.div>
    </div>
  );
}
